export function getHostContext() {
  const hostname = window.location.hostname.toLowerCase();

  const rootDomain = "agentbookcrm.com";

  const isRootDomain =
    hostname === rootDomain ||
    hostname === `www.${rootDomain}`;

  const isPlatformApp =
    hostname === `app.${rootDomain}` ||
    hostname === "localhost" ||
    hostname === "127.0.0.1";

  const isAgentBookSubdomain =
    hostname.endsWith(`.${rootDomain}`) && !isRootDomain;

  const isTenantSubdomain =
    isAgentBookSubdomain && !isPlatformApp;

  return {
    hostname,
    rootDomain,
    isRootDomain,
    isPlatformApp,
    isAgentBookSubdomain,
    isTenantSubdomain
  };
}